import React, { Component } from "react";
import AntdTable, { TableProps } from "antd/lib/table";
import PagePointEnhanced from "../page-point/pagePointEnhanced";
import { ConfigConsumer, ConfigConsumerEProps } from "../config-provider";
import "antd/lib/table/style";

export default class NativeTable extends Component<TableProps<object>> {
    render() {
        const { rowSelection, onRow } = this.props;
        return (
            <ConfigConsumer>
            {({ pagePoint }: ConfigConsumerEProps) => (
              <React.Fragment>
                {pagePoint ? (
                  <PagePointEnhanced
                    compType="Table"
                    {...this.props}
                    render={eventprops => (
                      <AntdTable
                        {...this.props}
                        rowSelection={
                            rowSelection ? { ...rowSelection,  ...(eventprops.onChange ? {onChange: eventprops.onChange}: {}) } : null
                        }
                        onRow = {eventprops.onRow ? eventprops.onRow : onRow}
                        data-ui-role='Table'
                      />
                    )}
                  ></PagePointEnhanced>
                ) : (
                  <AntdTable {...this.props} />
                )}
              </React.Fragment>
            )}
          </ConfigConsumer>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/native-table/index.tsx